import { render, staticRenderFns } from "./FeaturedOffer.vue?vue&type=template&id=93e52a88&lang=pug&"
import script from "./FeaturedOffer.vue?vue&type=script&lang=js&"
export * from "./FeaturedOffer.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedOffer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93e52a88')) {
      api.createRecord('93e52a88', component.options)
    } else {
      api.reload('93e52a88', component.options)
    }
    module.hot.accept("./FeaturedOffer.vue?vue&type=template&id=93e52a88&lang=pug&", function () {
      api.rerender('93e52a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/featured-offers/FeaturedOffer.vue"
export default component.exports